import MrbgNotifications from './MrbgNotifications';
import { activeFormPanel, mrbgStore, setActivePopups } from './mrbgRedux/index.js'
import React, { useState } from 'react'
import { mrbgTools } from '../../mrbgLib/mrbgTools.js'
import mrbgS2S from '../../mrbgLib/mrbgS2S.js'

function MrbgPanelHeader({hideMenu,setHideMenu,headerStyle}){

  const
    formsList = Object.values(mrbgStore.getState().mrbgVars.formsList);

  return(
    <header id={headerStyle.MP_header}>
      <ul>
        <li id={headerStyle.mrbgMenuIcon} onClick={()=>setHideMenu(!hideMenu)}>
          <i className="fa-regular fa-bars"></i>
        </li>
        <li id={headerStyle.MP_mehraz}>
          <a href="#" className={headerStyle.organizationalGradiant}>Developed By Mehraz Tech</a>
          <svg id={headerStyle.MP_mehrazLogo} viewBox="0 0 100 50" alt="مهرازتک - بابک گلبهاران">
            <path id={headerStyle.MP_MLF1} d="M80,17 l0,14.75 c0,3 -2.5,3 -3,3 l-3.5,0 c-3,0 -3,-3 -3,-3 l0,-0.75 l-11.25,15.75 c-1.5,2 -3,2.75 -4,3 l-4.75,0 c-3,0 -3,-3 -3,-3 l0,-16 l-11,15.75 c-1.5,2 -3,2.75 -4,3 l-7.75,0 c-0.4,0 -1.1,-0.6 -.8,-1.4 l22,-31.5 c1,-1.75 3,-3 4,-3 l4.25,0 c2,0 3,1.5 3,3 l0,16.25 l11.25,-16.25 c1,-1.75 3,-3 4,-3 l4.5,0 c2,0 3,1.5 3.1,3.4z"></path>
            <path id={headerStyle.MP_MLF2} d="M45.75,4.25 l0,7.75 l-8.25,11.75 c-0.25,.5 -0.75,.5 -1.25,-0.25 l0,-19.25 c0,-2.5 2.5,-3 3,-3 l3.5,0 c2,0 3,1.5 3,3 z"></path>
            <path id={headerStyle.MP_MLF3} d="M34.25,17 l0,11 l-8.5,12 c-0.25,.5 -0.75,.5 -1.25,0 l0,-9 l-11.25,15.75 c-1.5,2 -3,2.75 -4,3 l-7.5,0 c-0.4,0 -1.1,-0.6 -.85,-1.4 l22,-31.75 c1,-2 3,-3 4,-3 l4.25,0 c2,0 3,1.5 3.1,3.1z"></path>
            <path id={headerStyle.MP_MLF4} d="M34,4.5 l0,3.5 c0,3 -2.5,3 -3,3 l-3.5,0 c-3,0 -3,-3 -3,-3 l0,-3.5 c0,-2.5 2.5,-3 3,-3 l3.5,0 c2,0 3,1.5 3,3"></path>
            <path id={headerStyle.MP_MLE} d="M65,42 h6 v1.6 h-4.4 v1.6 h4.4 v1.6 h-4.4 v1.6 h4.4 v1.6 h-6 v-8.32z M72.15,42 h1.6 v3.2 h1.6 v-3.2 h1.6 v8 h-1.6 v-3.2 h-1.6 v3.2 h-1.6 v-8z M78.2,42 h2.9 c4.13,0.1 4.13,4.7 0,4.8 l2.9,1.84 l-0.844,1.36 l-5.136,-3.2 v-1.6 h2.9 c2.53,0 2.53,-1.6 0,-1.6 h-2.9 v-1.6z M84.5,50 l4.4,-8 h1.6 v8 h-3.4 l.88,-1.3 h1.1 v-4.2 l-3.1,5.55 h-1.74z M91.6,44 v-2 h6 v2 l-4.3,4.5 h2.7 v-.6 h1.6 v2 h-6 v-2 l4.3,-4.4 h-2.8 v.6 h-1.8z"></path>
          </svg>
          <div>
            <a href="tel:09384439494" className={headerStyle.organizationalGradiant}>
              <i className={`fa-regular fa-mobile ${headerStyle.organizationalGradiant}`}></i>
              <bdi>0938 443 9494</bdi>
            </a>
            <a href="tel:09384439494" className={headerStyle.organizationalGradiant}>
              <i className={`fa-regular fa-mobile ${headerStyle.organizationalGradiant}`}></i>
              <bdi>0917 500 9694</bdi>
            </a>
          </div>
        </li>
        {
          (formsList.intersect(['apoRes','apoResUpd'])).length?
            <>
              <MrbgPanelHeaderSearch {...{headerStyle}} />
              <li id={headerStyle.specialTimeLineIcon} onClick={()=>mrbgStore.dispatch(setActivePopups({fullPU:'MrbgSpecialDateTimeLinePopUp'}))}>🕒</li>
            </>:
            ''
        }
        <MrbgNotifications {...{headerStyle}}/>
      </ul>
    </header>
  )
}

function MrbgPanelHeaderSearch({headerStyle}){

  const
    [micCls,setMicCls] = useState(`${headerStyle.mrbgMicro} fa-solid fa-microphone-slash`);

  function search(e){
    var
      value  = e.target.nextElementSibling.value,
      formID = 'allSession',
      MD     = new FormData();

    if( !value )
      return;

    value = value.split(' ');
    MD.append('tblID',`${formID}__TB`)
    MD.append('cliPhone',value[value.length-1].replaceAll(/\(|\)/g,''));
    mrbgStore.dispatch(activeFormPanel(`${formID}__TFFrame`))
    mrbgS2S( `${formID}__TF`, MD, 'flt', 'apoSes' ).then(y=>console.log(y))
  }
  function listening(){
    if( mrbgTools.recog.listening ){
      mrbgTools.recog.stop()
      setMicCls(`${headerStyle.mrbgMicro} fa-solid fa-microphone-slash`);
    }
    else if( micCls==`${headerStyle.mrbgMicro} fa-solid fa-microphone ${headerStyle.activeMrbgMicro}` ){
      setMicCls(`${headerStyle.mrbgMicro} fa-solid fa-microphone-slash`);
    }
    // else{
    //   mrbgTools.recog.start();
    //   mrbgTools.recog.mrbgTI=refInp.current;
    //   setMicCls(`${headerStyle.mrbgMicro} fa-solid fa-microphone ${headerStyle.activeMrbgMicro}`);
    // }
  }

  return(
    <li id={headerStyle.searchFieldset} tabIndex="1">
      <span>🔍</span>
      <fieldset className={headerStyle.mrbgVoice}>
        <i className="fa-regular fa-search" onClick={e=>search(e)}></i>
        <input type="search" placeholder="search a name or phone" list="cli__DL" autoComplete="off"/>
        <i className={micCls} onClick={()=>listening()}></i>
      </fieldset>
    </li>
  )
}

export default MrbgPanelHeader;